import { LeadContainer, LeadText, LeadTitle } from "./ThankYou.style";

interface Props {
    isDesktop: boolean;
    fromMini?: boolean;
}

export default function ThankYou({ isDesktop, fromMini = false }: Props) {
    return (
    <LeadContainer isDesktop={isDesktop}>
        {fromMini ? (
            <>
                <LeadTitle>Din udvidede adfærdsanalyse er klar</LeadTitle>
                <LeadText>Se dine resultater og indsigter direkte i den mail, vi har sendt til dig.</LeadText>
                <LeadText>Analysen er baseret på dine svar og giver dig et mere nuanceret indblik i din adfærd.</LeadText>
                <LeadText><b>Kan du ikke finde mailen?</b><br />Tjek gerne din spammappe. Hvis den heller ikke er der, er du altid velkommen til at kontakte os.</LeadText>
            </>
        ) : (
            <>
                <LeadTitle>Tak - din udvidede adfærdsanalyse bliver sendt inden for kort tid.</LeadTitle>
                <LeadText>Vi er nu i gang med at udarbejde din udvidede adfærdsanalyse baseret på dine svar.</LeadText>
                <LeadText>Du modtager din analyse på din e-mail.</LeadText>
                <LeadText><b>Bemærk:</b> Tjek din spammappe, hvis du ikke kan se den i din indbakke. Hvis du ikke har modtaget din analyse inden for kort tid, er du meget velkommen til at kontakte os.</LeadText>
            </>
        )}
    </LeadContainer>
    )
}